import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuToppingModifierSelectionOption extends BaseFormModel<MenuToppingModifierSelectionOption> {
    id: number;
    menuModifier: MenuModifier;
    additionalPrice: number;
}
